import { CommonParams } from '@/api/resources/common/shared/models/common.models'

export enum SimpleListEntityEnum {
    SAMPLE_STATES = 'SAMPLE_STATES',
    CASE_STATE = 'CASE_STATE',
    CASE_TYPE = 'CASE_TYPE',
    PETITIONER = 'PETITIONER',
    REGIME = 'REGIME',
    HEALTH_MANAGEMENT_AREA = 'HEALTH_MANAGEMENT_AREA',
    PRIORITY = 'PRIORITY',
    CENTER = 'CENTER',
    PERSONNEL = 'PERSONNEL',
    PERSONNEL_TECHNICAL = 'PERSONNEL_TECHNICAL',
    PERSONNEL_PATHOLOGIST = 'PERSONNEL_PATHOLOGIST',
    PERSONNEL_EXPERT = 'PERSONNEL_EXPERT',
    PERSONNEL_ADMINISTRATIVE = 'PERSONNEL_ADMINISTRATIVE',
    PERSONNEL_RESIDENT = 'PERSONNEL_RESIDENT',
    PERSONNEL_PORTER = 'PERSONNEL_PORTER',
    PERSONNEL_GUEST = 'PERSONNEL_GUEST',
    PERSONNEL_STUDENT = 'PERSONNEL_STUDENT',
    DEPARTMENT = 'DEPARTMENT',
    INCIDENT_ORIGIN = 'INCIDENT_ORIGIN',
    INCIDENT_TYPE = 'INCIDENT_TYPE'
}

export interface SimpleListResponse {
    id: string
    label: string
}

export interface SimpleListParams extends CommonParams {
    active?: boolean // Indicates whether the results should contain only active/inactive entities. Null, the results will not be filtered by active/inactive status
    filter?: string // The filter text to apply to the returned results
    laboratoryId?: number // Laboratory Id
}
